import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { ISPUIRadioModule } from '@ispui/ng-radio';

import { RadioFieldComponent } from './radio.component';

import { ISPFieldType } from '../../model';

/**
 * Radio field module
 */
@NgModule({
  declarations: [RadioFieldComponent],
  imports: [
    CommonModule,
    ISPUIRadioModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: ISPFieldType.Radio,
          component: RadioFieldComponent,
        },
      ],
    }),
  ],
})
export class RadioFieldModule {}
